// extracted by mini-css-extract-plugin
export default {"shape":"Shape_shape__mwPQB","small":"Shape_small__KayZk","circle":"Shape_circle__4bK4C","triangle":"Shape_triangle__L-CFC","cross":"Shape_cross__6NYFQ","star":"Shape_star__RtAYX"};